<template>
  <SearchComboBox
    id="companySearchBox"
    ref="companySearchBox"
    name="company-search"
    :results="clientSearchResults"
    :initialValue="selectedCompanyName"
    type="text"
    labelName="Your employer's name"
    class="mb-3"
    :status="status"
    :errorText="errorText"
    :minimumCharacters="3"
    @selected="queryFragment"
    @changingInput="resetErrorState"
    @errorStateChanged="onErrorStateChanged"
  />
</template>

<script lang="ts">
import SearchComboBox from '@/components/search_combo_box/SearchComboBox.vue';
import { CLIENT_SEARCH_QUERY, CORPORATE_CLIENT_QUERY } from '@/graphql/bh_benefits/queries';
import { sendSegmentEvent } from '@/lib/segment';
import helperStatus from '@/helpers/status';

export default {
  name: 'CorporateClientComboBox',
  components: {
    SearchComboBox,
  },
  props: {
    preselectedId: {
      type: String,
      default: '',
    },
    errorText: {
      type: String,
      default:
        'You may not be eligible for Premium through employer benefits, please <a href="/registration?member_type=seeker" class="underline">sign up here</a>',
    },
  },
  data(): any {
    return {
      selectedCompanyName: '',
      clientSearchResults: [],
      status: helperStatus.Neutral,
    };
  },
  mounted() {
    if (this.preselectedId) {
      this.queryGetClientSlug(this.preselectedId);
    }
  },
  methods: {
    onErrorStateChanged(hasError) {
      if (hasError) {
        this.status = helperStatus.Error;
        this.invalidEmployerEntered();
      }
    },
    invalidEmployerEntered() {
      const date = new Date().toLocaleString('default', { month: 'long', day: 'numeric', year: 'numeric' });
      const time = new Date().toLocaleTimeString('default', { hour: 'numeric', minute: 'numeric', second: 'numeric' });
      sendSegmentEvent('Invalid Employer Entered', {
        click_date: date,
        time_stamp: time,
      });
    },
    resetErrorState(): void {
      this.status = helperStatus.Neutral;
    },
    async queryGetClientSlug(bhClientId: string) {
      await this.$apollo
        .query({
          query: CORPORATE_CLIENT_QUERY,
          variables: {
            bhClientId: Number(bhClientId),
          },
        })
        .then(({ data }) => {
          const { slug, name } = data.corporateClient;
          this.selectedCompanyName = name;
          this.$emit('selectedClient', { slug, name, bhClientId });
        })
        .catch((error) => {
          this.status = helperStatus.Error;
          this.$emit('selectedClient', { slug: '', name: '', bhClientId: '' });
          console.warn('GraphQL query error:', error);
        });
    },
    async queryFragment({ value, display }) {
      if (value) {
        // user selected client from dropdown
        this.queryGetClientSlug(value);
      } else {
        // user typing in fragment
        await this.$apollo
          .query({
            query: CLIENT_SEARCH_QUERY,
            variables: {
              fragment: display,
            },
          })
          .then(({ data }) => {
            const corporateClientsForComboBox = data.clientSearch.map(({ clientId, clientName }) => {
              return { display: clientName, value: `${clientId}` };
            });
            this.$emit('selectedClient', { slug: '', name: '', bhClientId: '' });
            this.clientSearchResults = corporateClientsForComboBox;
          })
          .catch((error) => {
            console.error('GraphQL query error:', error);
          });
      }
    },
  },
};
</script>
